/**
 * @param {Array<Record<string, any>>} result The array of records to transform
 * @param {Map<string, string> | null} replace - The map containing key replacements
 * @returns {Array<Record<string, any>>}
 */
const transformResultKeys = (result, replace) => {
  const transform = (item) => {
    return Object.entries(item).reduce((acc, [key, value]) => {
      if (replace?.has(key)) {
        return {
          ...acc,
          [replace.get(key)]: value[0],
        };
      }

      const transformed_key = key
        .replace(/[A-Z]+/g, (match) => "_" + match.toLowerCase())
        .substring(1);

      return {
        ...acc,
        [transformed_key]: value[0],
      };
    }, {});
  };

  return result?.map(transform);
};

export default transformResultKeys;
